/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketplaceType,
    AdminMarketplaceTypeFromJSON,
    AdminMarketplaceTypeFromJSONTyped,
    AdminMarketplaceTypeToJSON,
} from './AdminMarketplaceType';
import {
    AdminOrderPaymentType,
    AdminOrderPaymentTypeFromJSON,
    AdminOrderPaymentTypeFromJSONTyped,
    AdminOrderPaymentTypeToJSON,
} from './AdminOrderPaymentType';
import {
    AdminOrderStatusType,
    AdminOrderStatusTypeFromJSON,
    AdminOrderStatusTypeFromJSONTyped,
    AdminOrderStatusTypeToJSON,
} from './AdminOrderStatusType';
import {
    AdminOrderType,
    AdminOrderTypeFromJSON,
    AdminOrderTypeFromJSONTyped,
    AdminOrderTypeToJSON,
} from './AdminOrderType';

/**
 * 
 * @export
 * @interface AdminProductListOrders
 */
export interface AdminProductListOrders {
    /**
     * 
     * @type {string}
     * @memberof AdminProductListOrders
     */
    createdAt: string;
    /**
     * 
     * @type {AdminMarketplaceType}
     * @memberof AdminProductListOrders
     */
    marketplace?: AdminMarketplaceType;
    /**
     * 
     * @type {number}
     * @memberof AdminProductListOrders
     */
    marketplacePrice?: number;
    /**
     * 
     * @type {AdminOrderType}
     * @memberof AdminProductListOrders
     */
    orderType: AdminOrderType;
    /**
     * 
     * @type {AdminOrderPaymentType}
     * @memberof AdminProductListOrders
     */
    paymentType: AdminOrderPaymentType;
    /**
     * 
     * @type {number}
     * @memberof AdminProductListOrders
     */
    salePrice: number;
    /**
     * 
     * @type {AdminOrderStatusType}
     * @memberof AdminProductListOrders
     */
    status: AdminOrderStatusType;
    /**
     * 
     * @type {string}
     * @memberof AdminProductListOrders
     */
    statusCreatedAt: string;
}



export function AdminProductListOrdersFromJSON(json: any): AdminProductListOrders {
    return AdminProductListOrdersFromJSONTyped(json, false);
}

export function AdminProductListOrdersFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductListOrders {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'marketplace': !exists(json, 'marketplace') ? undefined : AdminMarketplaceTypeFromJSON(json['marketplace']),
        'marketplacePrice': !exists(json, 'marketplacePrice') ? undefined : json['marketplacePrice'],
        'orderType': AdminOrderTypeFromJSON(json['orderType']),
        'paymentType': AdminOrderPaymentTypeFromJSON(json['paymentType']),
        'salePrice': json['salePrice'],
        'status': AdminOrderStatusTypeFromJSON(json['status']),
        'statusCreatedAt': json['statusCreatedAt'],
    };
}

export function AdminProductListOrdersToJSON(value?: AdminProductListOrders | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'marketplace': AdminMarketplaceTypeToJSON(value.marketplace),
        'marketplacePrice': value.marketplacePrice,
        'orderType': AdminOrderTypeToJSON(value.orderType),
        'paymentType': AdminOrderPaymentTypeToJSON(value.paymentType),
        'salePrice': value.salePrice,
        'status': AdminOrderStatusTypeToJSON(value.status),
        'statusCreatedAt': value.statusCreatedAt,
    };
}

